import types from "resources/types";
import { createResourceListQuery } from "queries";

export const tagsQuery = (config = {}) =>
  createResourceListQuery(types.TAGS, {
    url: "/api/dev/tags/?limit=999",
    ...config,
  });
